import { Injectable } from '@angular/core';

declare var jquery: any;
declare var $: any;

@Injectable()
export class ModalHelper {

  constructor() { }

  public show(idModal: string, canIclose: boolean = true): void {
    if (canIclose == false) {
      $('#' + idModal).modal('show'); //display something
      //...

      // if you don't want to lose the reference to previous backdrop
      $('#' + idModal).modal('hide');
      $('#' + idModal).data('bs.modal', null); // this clears the BS modal data
      //...

      // now works as you would expect
      $('#' + idModal).modal({ backdrop: 'static', keyboard: false });
    } else {
      $('#' + idModal).modal('show');
    }

  }

  public hide(idModal: string): void {
    $('#' + idModal).modal('hide');
  }
}
